/**
 * Loading missions: the put-aways the office writes (rule 46).
 *
 * The enums repeat `@errebi/domain`'s on purpose: this package stays on `zod`
 * alone, because it ends up in the browser bundle.
 */
import { z } from 'zod';
export const zMacchinaCarico = z.enum(['modula-1', 'modula-2', 'slim']);
/** What a draft is made of, as the office saves it. */
export const zScriviMissioneCarico = z.object({
    descrizione: z.string().max(200),
    magazzino: zMacchinaCarico,
    righe: z
        .array(z.object({ variante: z.string().min(1), capi: z.number().int().positive() }))
        .max(1000),
});
/** The answer to «new mission»: the draft exists, this is its code. */
export const zNuovaMissioneCarico = z.object({ codice: z.string() });
export const zPostoCarico = z
    .object({ macchina: z.string(), udc: z.number().int(), scomparto: z.number().int() })
    .readonly();
/**
 * One line, with the catalogue's labels beside the variant. The labels may be
 * empty — the catalogue mirror can lag — and `sku` is `null` when the variant
 * has none: the line still shows, by its key.
 */
export const zRigaCarico = z
    .object({
    n: z.number().int(),
    variante: z.string(),
    capi: z.number().int(),
    /** Pieces the WMS says went in; `null` until it says anything. */
    evasa: z.number().int().nullable(),
    posto: zPostoCarico.nullable(),
    codice: z.string(),
    articolo: z.string(),
    colore: z.string(),
    taglia: z.string(),
    sku: z.string().nullable(),
})
    .readonly();
export const zStatoCarico = z.enum(['bozza', 'in-invio', 'inviata', 'annullata']);
export const zAvanzamentoCarico = z.enum([
    'bozza',
    'in-invio',
    'inviata',
    'in-corso',
    'fatta',
    'fatta-con-differenze',
    'annullata',
]);
export const zMissioneCarico = z
    .object({
    codice: z.string(),
    descrizione: z.string(),
    magazzino: zMacchinaCarico,
    stato: zStatoCarico,
    avanzamento: zAvanzamentoCarico,
    creataDa: z.string(),
    creataIl: z.string(),
    inviataIl: z.string().nullable(),
    ultimoErrore: z.string().nullable(),
    righe: z.array(zRigaCarico).readonly(),
    /** The pieces asked, summed over the lines. */
    pezzi: z.number().int(),
})
    .readonly();
export const zMissioniCarico = z
    .object({ missioni: z.array(zMissioneCarico).readonly() })
    .readonly();
//# sourceMappingURL=loading-missions.js.map